import { iconReloadWhite } from 'assets/icons';
import { Button } from 'components/Button';
import { AuthConnectionErrorProps, useAuth } from 'hooks/useAuth';
import { useHomeParams } from 'hooks/usePagesParams/useHomeParams';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { asParams } from 'utils/asParams';
import { formattingDate } from 'utils/formattingInputs';

// import { Container } from './styles';


interface NotificationProps {
  queueId: number,
  sentDate: string,
  subject: string,
  channel: string,
  address: string
  reSend: boolean
}
interface ParamsURLProps {
  id: string;
}

export const useNotificationsTable = () => {
  const {id} = useParams<ParamsURLProps>();
  const {connectApi, cancelRequest} = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<NotificationProps[]>([]);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const {params, setParams} = useHomeParams();
  const [pageNumber, setPageNumber] = useState<number>(params?.PageNumber ?? 1);
  const [requestsPerPage, setRequestsPerPage] = useState<number>(params?.RowsPerPage ?? 10); 

  

  const reesendNotification = async (event: any) => {
    const queueId = event.target.value;
    connectApi({
      type: 'post',
      url: `notifications/${queueId}/resend`,
      successMessage: 'E-mail/SMS enviado com sucesso!',
      errorMessage: 'Falha ao enviar e-mail/SMS',
    });
  }

  const buttonTable = ({ ...props }: NotificationProps) => {
    return (
      <Button
        label="Reenviar"
        value={props.queueId}
        disable={!props.reSend}
        typeBtn="blue"
        size="small"
        icon={iconReloadWhite}
        onClick={reesendNotification}
      />
    )
  }

  const getNotifications = async () => {
    setLoading(true);
    connectApi({
      type: 'get',
      url: `notifications?customerId=${id}&${filtersAsParams()}`,
      errorMessage: 'Falha ao listar notificações',
    }).then((response) => {
      setNotificationsCount(response.data.count);
      setNotifications(response.data.data.map((item:NotificationProps) => ({
        sentDate: formattingDate(item.sentDate, true),
        subject: item.subject,
        channel: item.channel,
        address: item.address,
        tdButton: buttonTable(item)
      })));
      setLoading(false);
    }).catch((error: AuthConnectionErrorProps) => {
      if (error.errorType === 'connection') {
        setError(true)
      }
      setLoading(false);
    });
  }

  const filtersAsParams = ():string => {
    var filters = [];
    filters.push({key: 'PageNumber', value: pageNumber.toString()});
    filters.push({key: 'RowsPerPage', value: requestsPerPage.toString()});
    return asParams(filters);
  };

  const handlePageSelected = (page: number):void => {
    setPageNumber(page);
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>):void => {
    const eventName = event.target.name;
    const eventValue = event.target.value;
    setRequestsPerPage(parseInt(eventValue));
  }

  useEffect(() => {
    setParams?.({
      ...params,
      PageNumber: pageNumber,
      RowsPerPage: requestsPerPage,
    });
    getNotifications();
  }, [pageNumber, requestsPerPage]);

  useEffect(() => {
    setPageNumber(1);
  }, [requestsPerPage]);
  
  return {
    loading,
    error,
    notifications,
    notificationsCount,
    pageNumber,
    requestsPerPage,
    handlePageSelected,
    handleRowsPerPageChange,
  };
}
